import { PLUGIN_TYPE } from '../../PluginType.ts';
import type { OpenPixCustomer } from '../openPixState.tsx';
import { getOpenPixState } from '../openPixState.tsx';
import type { AdditionalInfoItem } from '../OpenPixStore.tsx';
import { store } from '../OpenPixStore.tsx';

type PixPayPayload = {
  value: number;
  correlationID: string;
  description: string;
  customer: OpenPixCustomer;
  closeOnSuccess: boolean;
  additionalInfo: AdditionalInfoItem[];
  identifier: string;
  expiresIn: number;
  enableCashbackPercentage?: boolean;
  enableCashbackExclusivePercentage?: boolean;
  modal?: boolean;
  alwaysShowQrCode?: boolean;
  allowSimulatePayment?: boolean;
};
/**
 * $openpix.push([
 *  "pix",
 *  {
 *    value: 100,
 *    correlationID: 'correlationID',
 *    description: 'pay me',
 *    customer: {},
 *    closeOnSuccess: true
 * })
 */
export const pixPay = (args: PixPayPayload) => {
  const {
    value,
    correlationID,
    description,
    customer,
    closeOnSuccess,
    additionalInfo,
    expiresIn,
    enableCashbackPercentage = true,
    enableCashbackExclusivePercentage = true,
    modal = true,
    splits,
    alwaysShowQrCode = false,
    allowSimulatePayment = false,
  } = args;

  const openPixState = getOpenPixState();

  const getCustomer = () => {
    if (customer) {
      return {
        customer,
      };
    }

    return {};
  };

  const getSplits = () => {
    if (splits) {
      return {
        splits,
      };
    }

    return {};
  };

  store.setState({
    isOpen: true,
    value,
    description,
    correlationID,
    config: openPixState.config,
    success: false,
    closeOnSuccess,
    additionalInfo,
    expiresIn,
    isTemp: false,
    pluginType: PLUGIN_TYPE.PAYMENT,
    enableCashbackPercentage,
    enableCashbackExclusivePercentage,
    modal,
    alwaysShowQrCode,
    allowSimulatePayment,
    ...getCustomer(),
    ...getSplits(),
  });
};
